import {
	type DataPointTypeReportingFramework,
	ReportingFrameworkEnum,
} from "@/__generated__/types";

export const getDisplayedFrameworks = (
	activeReportingFramework: Partial<DataPointTypeReportingFramework>,
	reportingFrameworks: Partial<DataPointTypeReportingFramework>[],
) => {
	const { ESRS, GRI, DNK, CUSTOM, GHG, DERIVED, VSME } = ReportingFrameworkEnum;
	const alwaysShown =
		reportingFrameworks?.filter(
			(rf) =>
				rf.framework &&
				[ESRS, GRI, CUSTOM, GHG, DERIVED, VSME].includes(rf.framework),
		) ?? [];

	switch (activeReportingFramework?.framework) {
		case ESRS:
		case VSME:
		case GRI:
			return alwaysShown;
		case DNK:
			return [...alwaysShown, activeReportingFramework];
		case CUSTOM:
			return reportingFrameworks;
		default:
			return [];
	}
};
